export const DWELLINGS = "/dwellings";
export const DWELLING_DETAILS = "/dwelling/details/:id";
export const NEW_DWELLING = "/dwelling/new";
export const UPDATE_DWELLING = "/dwelling/update/:id/:isAssociatingBuilding";
export const UPDATE_DWELLING_DIAGNOSTIC = "/dwelling/update-diagnostic/:id";
export const DWELLING_DETAILS_ESTIMATE = "/dwelling/details/estimate/:id";
export const RECORDS = "/my-records";
export const SEARCH = "/search";
